export default "__VITE_ASSET__Dzmn3V$z__"